import { Link } from 'react-router'
import { NewsKicker } from '../news-meta/NewsKicker.tsx'
import { NewsMeta } from '../news-meta/NewsMeta.tsx'
import styles from './PostRow.module.css'

export interface PostRowProps {
  to: string
  title: string
  excerpt?: string
  coverUrl?: string | null
  kicker?: string
  author?: string
  date?: string | null
  readTimeMinutes?: number
  as?: 'h2' | 'h3'
  className?: string
}

/**
 * One story in a news river: thumbnail beside kicker, headline, dek and
 * byline. A story without a cover drops the thumbnail rather than showing an
 * empty box.
 */
export function PostRow({
  to,
  title,
  excerpt,
  coverUrl,
  kicker,
  author,
  date,
  readTimeMinutes,
  as: Heading = 'h3',
  className,
}: PostRowProps) {
  const classes = [styles.row, coverUrl ? styles.withThumb : '', className].filter(Boolean).join(' ')
  return (
    <Link to={to} className={classes}>
      {coverUrl && <img className={styles.thumb} src={coverUrl} alt="" />}
      <div className={styles.body}>
        {kicker && <NewsKicker>{kicker}</NewsKicker>}
        <Heading className={styles.title}>{title}</Heading>
        {excerpt && <p className={styles.excerpt}>{excerpt}</p>}
        <NewsMeta author={author} date={date} readTimeMinutes={readTimeMinutes} />
      </div>
    </Link>
  )
}
